"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var types_1 = require("./types");
require("./style.css");
var variantMapping = {
  body: 'p',
  largeTitle: 'h1',
  title1: 'h1',
  title2: 'h2',
  title3: 'h3'
};
var Text = function Text(_a) {
  var className = _a.className,
    dangerousHTML = _a.dangerousHTML,
    tag = _a.tag,
    children = _a.children,
    _b = _a.gutterBottom,
    gutterBottom = _b === void 0 ? false : _b,
    _c = _a.variant,
    variant = _c === void 0 ? types_1.TextVariant.BODY : _c,
    variantDesktop = _a.variantDesktop,
    _d = _a.center,
    center = _d === void 0 ? false : _d,
    _e = _a.noWrap,
    noWrap = _e === void 0 ? false : _e;
  var Tag = tag || (variantMapping === null || variantMapping === void 0 ? void 0 : variantMapping[variant]) || 'span';
  return react_1.default.createElement(Tag, {
    className: (0, clsx_1.default)(className, "text--".concat(variant), variantDesktop && "text--".concat(variantDesktop, "--desktop"), noWrap && 'text--noWrap', center && 'text--center', gutterBottom && 'text--gutterBottom'),
    dangerouslySetInnerHTML: dangerousHTML
  }, children);
};
exports.Text = Text;
exports.default = exports.Text;